import { render, staticRenderFns } from "./Firestore.vue?vue&type=template&id=74795b61&scoped=true"
import script from "./Firestore.vue?vue&type=script&lang=js"
export * from "./Firestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74795b61",
  null
  
)

export default component.exports